var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowBlack = function SvgArrowBlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4519 17.1002L12.0072 11.7973L17.5624 17.1002C18.1208 17.6333 19.0228 17.6333 19.5812 17.1002C20.1396 16.5672 20.1396 15.7062 19.5812 15.1731L13.0094 8.89977C12.451 8.36674 11.549 8.36674 10.9906 8.89977L4.41879 15.1731C3.8604 15.7061 3.8604 16.5672 4.41879 17.1002C4.97718 17.6196 5.89351 17.6333 6.4519 17.1002Z",
    fill: "#353247"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "ArrowBlack.d05c4b77eec8febc3cf2e656292e8de8.svg";